import React, { FC } from 'react';

export const IcUnsubscribe: FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9322 0C15.6966 0 17.9464 2.24839 17.9464 5.01169C17.9464 7.77548 15.6966 10.0239 12.9322 10.0239C10.1678 10.0239 7.91798 7.77548 7.91798 5.01169C7.91798 2.24839 10.1678 0 12.9322 0ZM12.9322 1.46698C10.9764 1.46698 9.38556 3.05719 9.38556 5.01169C9.38556 6.96669 10.9764 8.55689 12.9322 8.55689C14.888 8.55689 16.4789 6.96669 16.4789 5.01169C16.4789 3.05719 14.888 1.46698 12.9322 1.46698ZM12.9236 11.1345C16.4795 11.1345 19.2268 13.2856 20.4606 17.0372C20.5345 17.2606 20.4958 17.5061 20.3579 17.6968C20.2199 17.8875 19.9988 18 19.7635 18H6.06609C5.83079 18 5.60968 17.8875 5.47221 17.6968C5.33377 17.5061 5.29561 17.2606 5.36948 17.0372C6.58464 13.3414 9.40874 11.1345 12.9236 11.1345ZM12.9236 12.6015C10.485 12.6015 8.50619 13.87 7.33213 16.1325C7.23771 16.3144 7.37713 16.533 7.58259 16.533H18.2475C18.4529 16.533 18.5924 16.3144 18.4979 16.1325C17.3258 13.87 15.3529 12.6015 12.9236 12.6015ZM1.26319 9.17578C0.843039 9.17578 0.502441 9.51157 0.502441 9.92578C0.502441 10.34 0.843039 10.6758 1.26319 10.6758H6.2417C6.66184 10.6758 7.00244 10.34 7.00244 9.92578C7.00244 9.51157 6.66184 9.17578 6.2417 9.17578H1.26319Z"
        fill="#767676"
      />
    </svg>
  );
};
